import { mapGetters } from 'vuex';
import { VOCABULARIES } from '@/config/firestore';
import loaderMethods from '@/mixins/loader';

export default {
  mixins: [loaderMethods],
  computed: {
    ...mapGetters('user', ['userLanguages', 'userUid']),

    langSetFromUserLanguages() {
      return `${this.userLanguages.base}_${this.userLanguages.learning}`;
    },
  },
  methods: {
    async getMyVocabularyList(langSet = this.langSetFromUserLanguages) {
      this.showLoader();

      const db = await this.$firestore
        .collection(VOCABULARIES)
        .doc(this.userUid)
        .collection(langSet)
        .doc(this.userUid)
        .get()
        .then((doc) => doc);

      this.hideLoader();

      const vocabularyData = db.exists ? db.data() : false;

      if (vocabularyData && typeof vocabularyData === 'object') {
        return Object.values(vocabularyData);
      }

      return [];
    },
  },
};
